import React, { Suspense } from 'react';
import { routeStates } from './navigation/states.config';
import { UIRouter, UIView } from '@uirouter/react';
import useAuth from '~/modules/hooks/use-auth';
import StorageService from './services/storage-service';
import RouteService from './services/route-service';

const Router = () => {

	const { resumeSession } = useAuth();
	const [uiRouter] = React.useState(() => RouteService.registerStates(routeStates(resumeSession)));

	// Store last route visited before login (handle redirect URL)
	const currentRoute = window.location.pathname + window.location.search;
	if( !StorageService.get('lastRoute') ) {
		StorageService.set('lastRoute', currentRoute);
	}

	return <UIRouter router={uiRouter}>
		<Suspense fallback={<div></div>}>
			<UIView name="root"/>
		</Suspense>
	</UIRouter>;
};

export default Router;